import React from "react";
import { useLanguage } from "../context/LanguageContext";

const reviews = [
  {
    id: 1,
    name: "Pratyusha Maddali",
    rating: 5,
    comment:
      "The team made me feel comfortable from the moment I walked in. Everything was explained clearly, and I never felt rushed.",
  },
  {
    id: 2,
    name: "Mohana Krishnaveni",
    rating: 5,
    comment:
      "Dr. Sai Krishna and Dr. Thejasri are incredibly gentle and take the time to make sure you're completely at ease.",
  },
  {
    id: 3,
    name: "Sri Priya Narayanan",
    rating: 5,
    comment:
      "The best dental experience I've had in Secunderabad. Friendly staff, modern office, and great results.",
  },
  {
    id: 4,
    name: "Yalaveti Thulasi",
    rating: 5,
    comment:
      "Dr. Teja did orthodontics treatment on my son and she did a wonderful job. Highly recommend!",
  },
  {
    id: 5,
    name: "Gopi Krishna",
    rating: 5,
    comment:
      "Nice treatment and good response from the doctors. The clinic is very hygienic and modern.",
  },
];

const GoogleReviews = () => {
  const { t } = useLanguage();

  return (
    <section id="reviews" className="py-24 bg-white dark:bg-[#051518] text-gray-900 dark:text-slate-100 overflow-hidden transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top Header Line */}
        <div className="flex items-center space-x-4 mb-12 lg:mb-16 opacity-80">
          <div className="h-[1px] bg-gray-200 dark:bg-white/10 flex-grow"></div>
          <span className="text-sm tracking-widest uppercase font-semibold text-[#E09F3E]">{t.reviews.tag}</span>
        </div>

        {/* Heading & Intro */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-8 text-left">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light leading-tight text-gray-900 dark:text-white max-w-2xl">
            {t.reviews.heading}
          </h2>
          <p className="text-gray-600 dark:text-slate-300 max-w-md text-base md:text-lg leading-relaxed">
            {t.reviews.desc}
          </p>
        </div>

        {/* Testimonial Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {reviews.slice(0, 3).map((review) => (
            <div
              key={review.id}
              className="border border-gray-200/80 dark:border-white/5 rounded-3xl p-8 md:p-10 bg-gradient-to-b from-gray-50/50 to-white dark:from-[#0B252B] dark:to-[#0B252B] shadow-sm flex flex-col justify-between text-left hover:shadow-md hover:border-[#0F4C5C]/30 dark:hover:border-[#E09F3E]/30 transition-all duration-300 group"
            >
              <div>
                {/* 5 Stars */}
                <div className="flex space-x-1 mb-8 text-[#E09F3E]">
                  {Array(review.rating)
                    .fill(0)
                    .map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 fill-current"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                      </svg>
                    ))}
                </div>

                {/* Quote Text */}
                <p className="text-gray-700 dark:text-slate-200 text-lg md:text-xl font-light leading-relaxed mb-6">
                  “{review.comment}”
                </p>
              </div>

              {/* Author */}
              <div className="pt-4 border-t border-gray-100 dark:border-white/5 mt-4">
                <p className="text-[#0F4C5C] dark:text-[#E09F3E] font-semibold text-sm tracking-wide">
                  — {review.name}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note & Google Review Button */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 pt-4 text-left">
          <p className="text-gray-600 dark:text-slate-300 text-base md:text-lg font-light">
            We're proud to build lasting relationships with patients who trust us with their smiles.
          </p>
          <a
            href="https://www.google.com/maps/place/Dr.+Krishna's+Dental+Braces+%26+Implant+center/@17.4905101,78.5994577,17z/data=!3m1!5s0x3bcb9cf07ad9b185:0x83e5f61074131207!4m8!3m7!1s0x3bcb9d64f9c20e93:0x7df2ea8ca4e570f5!8m2!3d17.4905101!4d78.5994577!9m1!1b1!16s%2Fg%2F11wtvyrmxy?hl=en&entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center shrink-0 px-6 py-3 bg-[#0F4C5C] dark:bg-[#E09F3E] hover:bg-[#0a3844] dark:hover:bg-[#c98e35] text-white dark:text-[#0A2E36] font-medium rounded-full transition-all duration-300 text-sm shadow-sm"
          >
            Review us on Google
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
